import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { Field } from "react-final-form";

import { type CapacityCounterProps } from "../../organisms/AddEventTimesModal/AddEventTimesModal.types";

export const CapacityCounter = ({ name, label, required }: CapacityCounterProps) => {
  return (
    <Field name={name} initialValue={0}>
      {({ input }) => {
        const currentValue = input.value;

        const increment = () => {
          input.onChange(currentValue + 1);
        };

        const decrement = () => {
          input.onChange(Math.max(0, currentValue - 1));
        };

        const displayValue = currentValue === 0 ? "Unlimited" : currentValue.toString();

        return (
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {label}
              {required && " *"}
            </Typography>
            <Box
              sx={{
                alignItems: "center",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
                display: "flex",
                p: 1,
              }}
            >
              <IconButton
                size="small"
                onClick={decrement}
                disabled={currentValue === 0}
                sx={{ mr: 1 }}
                aria-label="Decrease capacity"
              >
                <RemoveIcon fontSize="small" />
              </IconButton>

              <Typography
                variant="body1"
                sx={{
                  flex: 1,
                  fontWeight: currentValue === 0 ? "normal" : "bold",
                  minWidth: "80px",
                  textAlign: "center",
                }}
              >
                {displayValue}
              </Typography>

              <IconButton size="small" onClick={increment} sx={{ ml: 1 }} aria-label="Increase capacity">
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        );
      }}
    </Field>
  );
};
